// Translated from Ruby backend validator: components/payroll_employees/app/services/payroll_employees/validators/portugal_ssn.rb

const SSN_LENGTH = 11
const SSN_REGEX = /^\d{11}$/
const PRIME_TABLE = [29, 23, 19, 17, 13, 11, 7, 5, 3, 2]

const isValidFirstDigit = (firstDigit: string): boolean => {
  return ['1', '2'].includes(firstDigit)
}

const isValidControlDigit = (ssn: string): boolean => {
  let sum = parseInt(ssn[ssn.length - 1] || '0')

  PRIME_TABLE.forEach((prime, index) => {
    sum += parseInt(ssn[index] || '0') * prime
  })

  return sum % 10 === 9
}

const validatePortugalSsn = (ssn: string): boolean => {
  if (!ssn || ssn.length !== SSN_LENGTH) {
    return false
  }

  if (!SSN_REGEX.test(ssn)) {
    return false
  }

  return isValidFirstDigit(ssn[0] || '') && isValidControlDigit(ssn)
}

export default validatePortugalSsn
